import React, { lazy, Suspense } from 'react';

import { detailsModalPropTypes } from '../../../propTypes';
import formatPrice from '../../../util/formatPrice';

import Carousel from '../Carousel';
import {
  ContentTypes,
  Features,
  Image,
  SingleMapPin,
  SplitImage,
  SplitVideo,
  Text,
  Video,
} from '../ContentComponents';
import Loading from '../Core/Loading';

const FullscreenModal = lazy(() => import('../FullscreenModal'));

const propTypes = detailsModalPropTypes;

const defaultProps = {
  closeModalText: 'close',
  currencySymbol: '£',
  googleApiKey: null,
  googleMapStyleId: null,
  images: undefined,
  title: '',
  subTitle: '',
  desc: '',
  price: undefined,
  durationMin: undefined,
  durationMax: undefined,
  motorhomeBerthText: 'Berth',
  motorhomeGearboxText: 'Gearbox',
  motorhomeType: undefined,
  motorhomeTypeText: 'Type',
  numberOfBerth: undefined,
  gearbox: undefined,
  priceFromText: 'Price From',
  viewDetailsCtaText: 'View Details',
};

function FullDetails(props) {
  const hasTiles =
    props.durationMin != null ||
    props.durationMax != null ||
    props.motorhomeType != null ||
    props.numberOfBerth != null ||
    props.gearbox != null ||
    (props.price != null && props.price !== 0);

  return (
    <Suspense fallback={<Loading />}>
      <FullscreenModal
        closeModalText={props.closeModalText}
        viewDetailsCtaText={props.viewDetailsCtaText}
      >
        <div className="FullDetails">
          {props.images && (
            <div className="FullDetails_carousel">
              <Carousel
                items={props.images}
                sideButtons
                title={props.title}
                subTitle={props.subTitle}
                description={props.desc}
              />
            </div>
          )}
          <div className="FullDetails_container">
            {hasTiles && (
              <div className="FullDetails_section">
                <div className="FullDetails_wrap-inset">
                  <div className="FullDetails_infoTileContainer">
                    {props.durationMin != null && props.durationMax != null && (
                      <div className="FullDetails_infoTile">
                        <p className="FullDetails_infoTileTitle">Duration</p>
                        {props.durationMin !== props.durationMax && (
                          // TODO: contains hardcoded text here - replace when available from backend
                          <p className="FullDetails_infoTileValue">
                            {props.durationMin} Night - {props.durationMax} Night stays
                          </p>
                        )}
                        {props.durationMin === props.durationMax && (
                          <p className="FullDetails_infoTileValue">
                            {props.durationMin} Night stay
                          </p>
                        )}
                      </div>
                    )}
                    {props.motorhomeType != null && (
                      <div className="FullDetails_infoTile">
                        <p className="FullDetails_infoTileTitle">{props.motorhomeTypeText}</p>
                        <p className="FullDetails_infoTileValue">{props.motorhomeType}</p>
                      </div>
                    )}
                    {props.numberOfBerth != null && (
                      <div className="FullDetails_infoTile">
                        <p className="FullDetails_infoTileTitle">{props.motorhomeBerthText}</p>
                        <p className="FullDetails_infoTileValue">{props.numberOfBerth} Berth</p>
                      </div>
                    )}
                    {props.gearbox != null && (
                      <div className="FullDetails_infoTile">
                        <p className="FullDetails_infoTileTitle">{props.motorhomeGearboxText}</p>
                        <p className="FullDetails_infoTileValue">{props.gearbox}</p>
                      </div>
                    )}
                    {props.price != null && props.price !== 0 && (
                      <div className="FullDetails_infoTile">
                        <p className="FullDetails_infoTileTitle">{props.priceFromText}</p>
                        <p className="FullDetails_infoTileValue">
                          {props.currencySymbol}
                          {formatPrice(props.price)}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

            {props.content?.map((content) => {
              let component = null;
              let isInset = false;

              switch (content.contentType.toLowerCase()) {
                case ContentTypes.Text:
                  component = <Text blockName="FullDetails" {...content.properties} />;
                  isInset = true;
                  break;
                case ContentTypes.Features:
                  component = <Features blockName="FullDetails" {...content.properties} />;
                  isInset = true;
                  break;
                case ContentTypes.Image:
                  component = <Image {...content.properties} />;
                  break;
                case ContentTypes.Video:
                  component = <Video {...content.properties} />;
                  break;
                case ContentTypes.SplitImage:
                  component = <SplitImage {...content.properties} />;
                  break;
                case ContentTypes.SplitVideo:
                  component = <SplitVideo {...content.properties} />;
                  break;
                case ContentTypes.SingleMapPin:
                  component = (
                    <SingleMapPin portalNode={props.portalNode} {...content.properties} />
                  );
                  break;
                default:
              }

              return (
                <Suspense key={content.id} fallback={<Loading />}>
                  <div className="FullDetails_section">
                    <div className={`FullDetails_wrap${isInset ? '-inset' : ''}`}>{component}</div>
                  </div>
                </Suspense>
              );
            })}
          </div>
        </div>
      </FullscreenModal>
    </Suspense>
  );
}

FullDetails.propTypes = propTypes;
FullDetails.defaultProps = defaultProps;

export default FullDetails;
